import React from "react";
import CommonButton from "../../../components/commonButton";
import { routes } from "../../../routes/pageRoutes";
import { PlusIcon } from "../../../assets/icons";
import { TableSearch } from "../../../components/form/Fields";
import { FilterBtn } from "../../../components/commonButton/btns";

const NpaAddImpExprtBtn = ({
  filterValues,
  navigate,
  setFilterModal,
  searchQuery,
  setSearchQuery,
  canCreate,
  cardStatus,
}) => {
  // Check if any value except 'search' is non-empty
  // Treat non-empty arrays and non-empty trimmed strings as "active"
  const hasValue = (v) =>
    Array.isArray(v) ? v.length > 0
      : typeof v === "string" ? v.trim() !== ""
        : v != null && v !== false; // safety for future booleans/numbers

  const isFilterActive = Object.entries(filterValues)
    .filter(([key]) => key !== "search") // exclude search
    .some(([, value]) => hasValue(value));

  const isPublicCard = cardStatus === "public";

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div className="d-flex  align-items-center gap-4">

          <TableSearch value={searchQuery} // Use the immediate typing state
            placeholder="City, state, property, transaction"
            onChange={(e) => {
              // Update the searchQuery state with every keystroke.
              // The debounce useEffect will handle updating the filterValues.
              setSearchQuery(e.target.value);
            }} />
          <FilterBtn onClick={() => setFilterModal(true)} active={isFilterActive} />
        </div>

        {canCreate && (
          <CommonButton
            icon={<PlusIcon size={14} />}
            variant="primary"
            title={isPublicCard ? "Add Public Property" : "Add Property"}
            onClick={(e) => {
              e.stopPropagation();
              navigate(routes.addBrokerProperty, {
                state: { isPublicProperty: isPublicCard },
              });
            }}
          />
        )}
      </div>

    </>
  );
};

export default NpaAddImpExprtBtn;
